<template>
  <div class="maxBox">
    <div style="width:100%;margin:5px auto;display: flow-root;margin-bottom: 60px;">
      <div style="position: sticky;top: 0;z-index: 999;">
        <van-tabs v-model="active" color="#ffc002" @click="onClick" :sticky="true">
          <van-tab title="全部" name="0"></van-tab>
          <van-tab title="待下单" name="1"></van-tab>
          <van-tab title="待接单" name="2"></van-tab>
          <van-tab title="已接单" name="4"></van-tab>
          <van-tab title="已结单" name="6"></van-tab>
          <van-tab title="退款中" name="7"></van-tab>
          <van-tab title="已退款" name="8"></van-tab>
          <!-- <van-tab title="已评价"></van-tab> -->
          <van-tab title="已撤单" name="9"></van-tab>
          <van-tab title="已拒绝" name="10"></van-tab>
        </van-tabs>
      </div>

      <!-- <van-sidebar v-model="activeKey"
            color="#ffc002"
            style="
            width: 25%;
            float: left;
            position: fixed;
            overflow-y: scroll;
            height: 87%;
          ">
            <van-sidebar-item :title="item.Name"
              v-for="item in ServiceType"
              :key="item.id"
              @click="orderType(item.id)">
            </van-sidebar-item>
          </van-sidebar> -->
      <div
        style="
            margin: 0px auto;
            display: flow-root;
            width: 95%;
          "
      >
        <van-list
          :loading="loading"
          :finished="finished"
          finished-text="没有更多了"
          :offset="1"
          :immediate-check="false"
          @load="onLoad"
        >
          <div v-for="item in ServiceList" :key="item.SId" class="borderClass">
            <div class="van-card" @click="getOrder('/ylOrder/orderList/orderMy/' + item.OrderId)">
              <div class="van-card__header">
                <a class="van-card__thumb">
                  <div class="van-image" style="width: 100%; height: 100%;">
                    <img
                      v-if="item.SerImg == null"
                      style="width: 100%; height: 100%"
                      src="https://alyimg-zhyl.anluoyun.cn/xaxmzj/images/1716543211784.png"
                    />
                    <img
                      v-else
                      :src="item.SerImg.split(',')[0]"
                      :onerror="onErrorImg('https://alyimg-zhyl.anluoyun.cn/xaxmzj/images/1716544320187.png')"
                      class="van-image__img"
                      style="object-fit: cover;border-radius: 8px;"
                    />
                  </div>
                  <!-- <div class="van-image"
                  style="width: 100%; height: 100%;"
                  v-else>
                  <img :src="item.SerImgUrl"
                   :onerror="onErrorImg('https://lycaljdapi.dexian.ren//upload/images/2021/12/3559e43a-6b7.png')"
                    class="van-image__img"
                    style="object-fit: cover;border-radius: 8px;">
                </div> -->
                </a>
                <div class="van-card__content">
                  <div>
                    <div class="status van-multi-ellipsis--l2">
                      <span v-if="item.Status == 1" style="color: #3baef5">待下单</span>
                      <span v-if="item.Status == 2" style="color: #E6A23C">待接单</span>
                      <span v-if="item.Status == 3" style="color: #ffc002">派单中</span>
                      <span v-if="item.Status == 4" style="color: #fc7d0a">已接单</span>
                      <span v-if="item.Status == 5" style="color: rgb(194, 162, 58)">配送中</span>
                      <span v-if="item.Status == 6" style="color: #67c23a">已结单</span>
                      <span v-if="item.Status == 7" style="color: #c29e3a">退款中</span>
                      <span v-if="item.Status == 8" style="color: #e61549">已退款</span>
                      <span v-if="item.Status == 9" style="color: #e61549">已撤销</span>
                      <span v-if="item.Status == 10" style="color: #e67315">已拒绝</span>
                      <!-- <span>{{item.StatusDesc}}</span> -->
                    </div>
                    <div
                      class="van-card__desc van-ellipsis"
                      style="font-weight: 600;color: black;font-size:16px;margin-top:15px;"
                    >
                      服务数量：{{ item.SerNum }}
                    </div>
                  </div>
                  <div class="van-card__bottom">
                    <div class="van-card__price">
                      <div>
                        <span
                          class="van-card__price-integer"
                          style="color: #ff7e1e;margin-bottom:20px;"
                          v-if="item.Amount == '0'"
                          >现金支付</span
                        >
                        <span class="van-card__price-integer" v-else style="color: red;margin-bottom:20px;"
                          >￥ <span>{{ item.Amount }}</span> 元</span
                        >
                      </div>
                      <div v-if="item.Status == '6'">
                        <span class="van-card__price-integer" style="color: red;margin-bottom:20px;">
                          <van-rate
                            v-model="item.Satisfaction"
                            :size="25"
                            color="#ffd21e"
                            void-icon="star"
                            void-color="#eee"
                            readonly
                          >
                          </van-rate>
                        </span>
                      </div>
                      <div v-if="item.Status == '10'">
                        <span class="van-card__price-integer" style="color: rgb(61, 59, 59);padding-top:10px;">
                          {{ item.RefundReason }}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              v-if="item.Status == '5'"
              style="background-color: #fafafa;"
              @click="getOrder('/ylOrder/orderList/orderMy/' + item.OrderId)"
            >
              <div style="margin-left:10px;margin-bottom:10px;">{{ item.EvalContent }}</div>
              <div v-if="item.EvalImgs != null && item.EvalImgs != ''">
                <span v-for="(imgurl, index) in item.EvalImgs.split(',')" :key="index">
                  <img :src="url + imgurl" style="width:75px;height:75px;margin:10px;border-radius: 8px;" />
                </span>
              </div>
            </div>
            <div class="buttonClass">
              <van-button
                size="small"
                class="buttonClassType"
                plain
                v-if="item.Status == '6' && item.EvaStatus == '1'"
                color="#ffc002"
                type="primary"
                @click="appraise('/ylOrder/orderList/appraise/' + item.OrderId)"
              >
                评 价
              </van-button>
              <van-button
                size="small"
                class="buttonClassType"
                v-if="item.Status == '1'"
                color="#3baef5"
                plain
                type="primary"
                @click="orderRen(item.OrderId)"
              >
                下 单
              </van-button>
              <van-button
                size="small"
                v-if="item.Status == '1'"
                color="#ffc002"
                plain
                class="buttonClassType"
                type="primary"
                @click="getRevokeOrder(item)"
              >
                撤 单
              </van-button>
              <van-button
                size="small"
                v-if="item.Status == '2'"
                color="#ffc002"
                plain
                class="buttonClassType"
                type="primary"
                @click="getRefundShowOrder(item)"
              >
                退 款
              </van-button>
              <van-button
                size="small"
                v-if="item.Status == '1'"
                plain
                class="buttonClassType"
                type="warning"
                @click="delet(item)"
              >
                删 除
              </van-button>
            </div>
            <!-- <div style="float: left;margin:5px 0;border-bottom:1px solid #C6C6C6;">
            <div class="van-ellipsis title">{{item.StaName}}</div>
            <div class="status">{{item.StatusDesc}}</div>
            <div v-if="item.SerImg != '' && item.SerImg != null"
              style="float:left;width:25%;">
              <img :src="item.SerImgUrl"
                style="width:100%;border-radius: 5px;" />
            </div>
            <div v-else
              style="float:left;width:25%;">
              <img src="http://lycaljdapi.dexian.ren//upload/images/2021/12/aa7c3ea2-bfd.png"
                style="width:100%;border-radius: 5px;" />
            </div>
            <div style="float:left;margin-left:5px;font-size: 14px;color: #646566;    width: 60%;">
              <span style="line-height:30px;">服务数量：{{item.SerNum}}<br />
                <span v-if="item.Amount != '0'">合计金额：{{item.Amount}}元<br /></span>
                <span v-if="item.Amount == '0'">
                  <van-tag plain
                    type="primary"
                    color="#ffc002">现金支付</van-tag><br />
                </span>
              </span>
            </div>

          <div v-if="item.Status == '5'">
            <div style="margin:5px 0;">
              <van-rate v-model="item.Satisfaction"
                :size="25"
                color="#ffd21e"
                void-icon="star"
                void-color="#eee"
                readonly>
              </van-rate>
            </div>
            <div>{{item.EvalContent}}</div>
            <img :src='SerImg'
              style="width:75px;height:75px;margin:10px;border-radius: 5px;" />
          </div>
        </div> -->
          </div>
        </van-list>
      </div>
      <!-- 撤单原因 -->
      <van-dialog v-model="arriveShow" title="提示" show-cancel-button :beforeClose="beforeClose">
        <van-field v-model="dataForm.RevReason" label="撤单原因" placeholder="请输入撤单原因" />
      </van-dialog>
      <!-- 退款原因 -->
      <van-dialog v-model="refundShow" title="提示" show-cancel-button :beforeClose="beforeRefund">
        <van-field v-model="dataForm.RefundReason" label="退款原因" placeholder="请输入退款原因" />
      </van-dialog>
      <van-action-sheet v-model="orderRenshow" title="配送老人" @close="close()">
        <div class="content">
          <van-radio-group
            v-model="oldManList"
            v-for="item in MyBindInfoList"
            :key="item.BindId"
            style="margin: 10px;padding:15px 10px;background: #f6f7f8;border-radius: 5px;"
          >
            <van-radio :name="item.BindId" checked-color="#ffc002" style="padding: 20rpx;">
              <div style="font-size: 18px;font-weight: 600;margin-bottom: 10rpx;margin: 5px;">
                {{ item.Name }}
                <span style="font-weight: 500;">{{ item.Mobile }}</span>
                <span style="padding-left: 20px;" @click="updata(item)"> <van-icon name="edit"/></span>
                <span style="padding-left: 20px;" @click="addOldMan()"> <van-icon name="add-o"/></span>
              </div>
              <!-- <div style="font-size: 14px;margin-bottom: 10rpx;">{{item.Summary}}</div> -->
              <div style="margin: 5px;">{{ item.Addr }}</div>
            </van-radio>
          </van-radio-group>
          <div style="">
            <div style="width: 95%; bottom: 0; position: fixed; padding: 10px">
              <van-button
                round
                type="primary"
                size="normal"
                style="font-size: 16px; width: 100%;float:none;"
                color="black"
                @click="addOrder()"
              >
                确定
              </van-button>
            </div>
          </div>
        </div>
      </van-action-sheet>

      <van-action-sheet v-model="orderRenAddshow" title="配送老人信息" @close="close()">
        <div class="content">
          <van-field
            v-model="oldmanForm.Name"
            class="shuru"
            name="oldmanForm.Name"
            label="收件人"
            placeholder="请输入收件人"
          />
          <van-field
            v-model="oldmanForm.Mobile"
            class="shuru"
            name="oldmanForm.Mobile"
            label="联系电话"
            placeholder="请输入老人联系电话"
          />
          <van-field
            v-model="oldmanForm.Addr"
            type="textarea"
            rows="1"
            autosize
            class="shuru"
            name="oldmanForm.Addr"
            label="居住地址"
            placeholder="请输入老人现居住地址"
          />
          <!-- <van-field
            v-model="oldmanForm.OMIdCard"
            class="shuru"
            name="oldmanForm.OMIdCard"
            label="身份证号"
            placeholder="请输入身份证号"
          />
          <van-field
            v-model="oldmanForm.OMMobile"
            class="shuru"
            name="oldmanForm.OMMobile"
            label="联系电话"
            placeholder="请输入老人联系电话"
          />
          <van-field
            v-model="oldmanForm.OMAddr"
            type="textarea"
            rows="1"
            autosize
            class="shuru"
            name="oldmanForm.OMAddr"
            label="居住地址"
            placeholder="请输入老人现居住地址"
          /> -->
          <div style="width: 95%; bottom: 0; position: fixed; padding: 10px">
            <van-button round block type="info" color="black" @click="submit()">保存</van-button>
          </div>
        </div>
      </van-action-sheet>
      <van-empty v-if="orderListShow" description="暂无数据" />
    </div>
    <!-- 确认弹窗 -->
    <van-dialog
      v-model="memberShow"
      title="提示"
      message="未注册请先进行注册"
      show-cancel-button
      :beforeClose="beforeCloseMember"
    >
    </van-dialog>
    <van-tabbar
      v-model="activeTab"
      v-if="fwStyle == '2'"
      @change="onChangeTab"
      active-color="#ffc002"
      inactive-color="#000"
    >
      <van-tabbar-item icon="home-o">首页</van-tabbar-item>
      <van-tabbar-item icon="chat-o">订单</van-tabbar-item>
      <!-- <van-tabbar-item icon="manager-o">我的</van-tabbar-item> -->
    </van-tabbar>
  </div>
</template>

<script>
import {
  WeGetServiceList,
  WeGetMyOrderPage,
  WeRevokeOrder,
  WeDeleteOrder,
  WePlaceOrder,
  WeGetMyBindInfoPage,
  WeSaveBindInfo,
  ApplyRefund,
} from '@/api/ylOrder.js'
import { setOpenId, getOpenId, removeOrderId, getfwStyle } from '@/utils/auth'
import Vue from 'vue'
import { Toast } from 'vant'
import { Dialog } from 'vant'
Vue.use(Dialog)
Vue.use(Toast)
export default {
  data() {
    return {
      ServiceList: [],
      active: 0,
      activeKey: 0,
      activeTab: 1,
      show: false,
      orderListShow: false,
      arriveShow: false,
      status: '0',
      ServiceType: [
        { Name: '助餐', id: '1' },
        { Name: '助洁', id: '2' },
        { Name: '助行', id: '3' },
        { Name: '助浴', id: '4' },
        { Name: '助医', id: '5' },
        { Name: '康复', id: '6' },
        { Name: '巡访关爱', id: '7' },
        { Name: '其他', id: '99' },
      ],
      SerImg: [],
      EvalImgs: [],
      url: 'http://lycaljdapi.dexian.ren/',
      dataForm: {
        RevReason: '',
        RefundReason: '',
      },
      oid: '',
      oldManList: '',
      MyBindInfoList: [],
      orderRenshow: false,
      orderRenAddshow: false,
      oldmanForm: {
        Name: '',
        Mobile: '',
        Addr: '',
        BindId: undefined,
      },
      listfrom: {
        page: 1,
        limit: 10,
      },
      orId: '',
      hidden: true, //没有更多数据了
      loading: true, //加载
      finished: false, //数据完全加载结束为 true
      total: undefined, //数据条数
      fwStyle: '',
      refundShow: false,
      memberShow: false,
    }
  },
  created() {
    // 获取并保存openid
    if (this.$route.query['openid']) {
      setOpenId(this.$route.query['openid'])
    }
    this.fwStyle = getfwStyle()
    this.getServiceList()
    window.wx.miniProgram.postMessage({
      //wxSdk为微信sdk
      data: {
        shareTitle: '养老美团', //自定义
        // shareUrl: 'shareUrl', //自定义
        path: '/ylOrder/orderList',
      },
    })
  },
  methods: {
    beforeCloseMember(action, done) {
      if (action === 'confirm') {
        this.$router.push({
          path: '/ylOrder/memberList',
        })
      } else if (action === 'cancel') {
        done() //关闭
      }
    },
    // 底部导航栏切换
    onChangeTab: function(row) {
      console.log(row)
      if (row == '0') {
        if (window.__wxjs_environment === 'miniprogram') {
          // window.wx.miniProgram.redirectTo({
          //   url: '../meiTuan/meiTuanShouYe?path=/ylOrder',
          // })
          window.wx.miniProgram.redirectTo({
            url: '../public/goto?path=/ylOrder',
          })
          // this.$router.push({
          //   path: '/ylOrder',
          // })
        } else {
          this.$router.push({
            path: '/ylOrder',
          })
        }
        // this.$router.push({
        //   path: "/ylOrder",
        // });
      }
      if (row == '2') {
        if (window.__wxjs_environment === 'miniprogram') {
          window.wx.miniProgram.redirectTo({
            url: '../public/goto?path=/ylOrder/personal',
          })
        } else {
          this.$router.push({
            path: '/ylOrder/personal',
          })
        }
        // this.$router.push({
        //   path: "/ylOrder/personal",
        // });
      }
    },
    onErrorImg: function(imgSrc) {
      return 'this.οnerrοr=null;this.src=' + '"' + imgSrc + '";'
    },
    onLoad() {
      this.listfrom.page = this.listfrom.page + 1
      this.loading = true
      this.getServiceList()
    },
    onClick: function(name, title) {
      this.status = name
      this.listfrom.page = 1
      this.ServiceList = []
      this.finished = false
      this.loading = true

      this.getServiceList()
      // else if (this.oType == '2') {
      //   this.oSerKind = undefined
      //   this.getServiceList();
      // }
    },

    getOrder: function(row) {
      if (window.__wxjs_environment === 'miniprogram') {
        window.wx.miniProgram.navigateTo({
          url: '../public/goto?path=' + row,
        })
      } else {
        this.$router.push(row)
      }
      // this.$router.push("/ylOrder/currentOrder/" + row + "/" + this.oCode);
    },
    // 服务项目类型
    orderType: function(row) {
      console.log(row)
      this.oSerKind = row
      this.getServiceList()
    },
    getServiceList: function() {
      this.listfrom.status = this.status
      this.listfrom.openID = getOpenId()
      setTimeout(() => {
        WeGetMyOrderPage(this.listfrom).then((res) => {
          this.loading = false
          if (res.data.code == '0') {
            let rows = res.data.data //请求返回当页的列表
            // 加载状态结束

            if (res.data.code == 0) {
              if (rows == null || rows.length === 0) {
                // 加载结束
                console.log('结束')
                this.finished = true
                return
              }
              // 将新数据与老数据进行合并
              this.ServiceList = this.ServiceList.concat(rows)

              //如果列表数据条数>=总条数，不再触发滚动加载
              if (this.ServiceList.length >= res.data.count) {
                this.finished = true
              }
            }
            // if (res.data.data.length != '0') {
            //   this.ServiceList = res.data.data;
            //   this.orderListShow = false
            // } else {
            //   // Toast.success('暂未下单');
            //   this.ServiceList = []
            //   this.orderListShow = true
            // }
          } else if (res.data.code == '1') {
            this.memberShow = true
            this.finished = true
          } else {
            Toast.fail(res.data.msg)
            this.finished = true
          }
        })
      }, 500)
    },
    // 撤单
    getRevokeOrder: function(row) {
      this.arriveShow = true
      console.log(row.OrderId)
      this.oid = row.OrderId
    },
    beforeClose(action, done) {
      if (action === 'confirm') {
        setTimeout(done, 1000)
        WeRevokeOrder({ OpenID: getOpenId(), OrderId: this.oid, RevReason: this.dataForm.RevReason }).then((res) => {
          if (res.data.code == 0) {
            Toast.success('撤单成功')
            this.ServiceList = []
            this.oid = ''
            this.getServiceList()
          }
        })
      } else if (action === 'cancel') {
        done() //关闭
      }
    },
    // 申请退款
    getRefundShowOrder: function(row) {
      this.refundShow = true
      this.dataForm.RefundDesc == ''
      this.oid = row.OrderId
    },
    beforeRefund(action, done) {
      if (action === 'confirm') {
        setTimeout(done, 1000)
        if (this.dataForm.RefundReason == '') {
          Toast.fail('请输入退款原因')
          return
        }
        ApplyRefund({ OpenID: getOpenId(), OrderId: this.oid, RefundReason: this.dataForm.RefundReason }).then(
          (res) => {
            if (res.data.code == 0) {
              Toast.success('已提交申请')
              this.ServiceList = []
              this.oid = ''
              this.getServiceList()
            }
          }
        )
      } else if (action === 'cancel') {
        done() //关闭
      }
    },
    // 删除订单
    delet: function(row) {
      console.log(row.OrderId)
      WeDeleteOrder({ OpenID: getOpenId(), OrderId: row.OrderId }).then((res) => {
        if (res.data.code == 0) {
          Toast.success('删除成功')
          this.ServiceList = []
          this.getServiceList()
          removeOrderId()
        } else {
          Toast.fail(res.data.msg)
        }
      })
    },
    //下单
    addOrder: function() {
      // Dialog.confirm({
      //   title: "提示",
      //   message: "确定要下单吗!",
      // })
      //   .then(() => {
      WePlaceOrder({ OpenID: getOpenId(), OrderId: this.orId, BindId: this.oldManList }).then((res) => {
        if (res.data.code == '0') {
          const datas = res.data.data
          if (datas == '1') {
            Toast.success('下单成功')
          } else if (window.__wxjs_environment === 'miniprogram') {
            var url =
              '/pages/pay/pay?appid=' +
              datas.appid +
              '&nonceStr=' +
              datas.nonceStr +
              '&prepay_id=' +
              datas.prepay_id +
              '&signType=MD5&key=' +
              datas.key +
              '&OrderId=' +
              datas.OrderId
            window.wx.miniProgram.navigateTo({
              url: url,
            })
            // window.wx.miniProgram.redirectTo({
            //   url: url
            // });
          }
          // Toast.success('下单成功');
          this.ServiceList = []
          this.getServiceList()
          this.showPopupShow = false
          this.orderRenshow = false
        } else {
          Toast.fail(res.data.msg)
        }
      })
      // })
    },
    // 评价
    appraise: function(row) {
      if (window.__wxjs_environment === 'miniprogram') {
        window.wx.miniProgram.navigateTo({
          url: '../public/goto?path=' + row,
        })
      } else {
        this.$router.push(row)
      }
      // this.$router.push("/ylOrder/orderList/appraise/" + row.OrderId);
    },
    close: function() {
      // console.log(123123);
      this.oldManList = ''
      this.oldmanForm.Name = ''
      this.oldmanForm.Mobile = ''
      this.oldmanForm.Addr = ''
    },
    add: function(row) {
      console.log(row)
    },
    // 下单人
    orderRen: function(row) {
      console.log(row)
      this.orId = row
      this.orderRenshow = true
      this.getMyBindInfoPage()
    },
    getMyBindInfoPage: function() {
      WeGetMyBindInfoPage({ openID: getOpenId(), page: '1', limit: '999' }).then((res) => {
        if (res.data.code == '0') {
          if (res.data.data.length != '0') {
            this.MyBindInfoList = res.data.data
            // this.orderListShow = false
          } else {
            // Toast.fail('未绑定老人信息');
            this.MyBindInfoList = []
            this.orderRenshow = false
            this.orderRenAddshow = true
            // this.orderListShow = true
          }
        } else {
          Toast.fail(res.data.msg)
        }
      })
    },
    // 添加老人信息
    submit() {
      console.log(this.oldmanForm)
      var reg = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/
      // if (!reg.test(this.oldmanForm.OMIdCard)) {
      //   Toast.fail('身份证号码不正确')
      // } else if (this.oldmanForm.OMMobile == '') {
      //   Toast.fail('请输入老人联系电话')
      // } else if (this.oldmanForm.OMAddr == '') {
      //   Toast.fail('请输入老人现居住地址')
      // }
      if (this.oldmanForm.Name == '') {
        Toast.fail('请输入收件人')
      } else if (this.oldmanForm.Mobile == '') {
        Toast.fail('请输入老人联系电话')
      } else if (this.oldmanForm.Addr == '') {
        Toast.fail('请输入老人现居住地址')
      } else {
        WeSaveBindInfo({
          OpenID: getOpenId(),
          Name: this.oldmanForm.Name,
          Mobile: this.oldmanForm.Mobile,
          Addr: this.oldmanForm.Addr,
          BindId: this.oldmanForm.BindId,
        }).then((res) => {
          if (res.data.code == '0') {
            Toast.success('绑定成功')
            this.orderRenAddshow = false
            this.orderRenshow = true
            this.oldmanForm.OMIdCard = ''
            this.oldmanForm.OMMobile = ''
            this.oldmanForm.OMAddr = ''
            this.oldmanForm.BindId = undefined
            this.getMyBindInfoPage()
          } else {
            Toast.fail(res.data.msg)
          }
        })
      }
    },
    addOldMan: function() {
      this.orderRenAddshow = true
    },
    // 编辑老人信息
    updata: function(row) {
      this.orderRenAddshow = true
      console.log(row)
      this.oldmanForm = Object.assign({}, row)
    },
  },
}
</script>

<style scoped>
.maxBox {
  background-color: #f9f9f9;
  min-height: 100%;
}
.borderClass {
  /* box-shadow: 0px 5px 17px 1px rgb(0 0 0 / 7%);
  border-radius: 5px; */
}
.van-card {
  background-color: white;
  border-radius: 5px;
  margin-top: 8px;
}
/* .van-button__content {
  float: left !important;
} */
.van-button__text {
  display: inline-grid !important;
}
.van-action-sheet {
  height: 500px !important;
}
.van-action-sheet__content {
  margin-bottom: 70px !important;
}
.van-sidebar-item--select::before {
  background-color: #ffc002 !important;
}
.title {
  margin: 10px 0;
  font-size: 17px;
  font-weight: 600;
  width: 70%;
  float: left;
}
.status {
  margin: 11px 0;
  font-size: 16px;
  width: 25%;
  float: right;
  text-align: center;
  color: #646566;
}
.buttonClass {
  width: 100%;
  text-align: right;
  margin-right: 10px;
  background-color: white;
  border-bottom-left-radius: 5px;
  border-bottom-right-radius: 5px;
}
.buttonClassType {
  margin: 5px;
  padding: 0 15px;
  border-radius: 5px;
  font-size: 16px;
}
</style>
